export const SET_ADMINISTRATIVE_USERS = 'SET_ADMINISTRATIVE_USERS'
export const ADD_ACTIVE_REQUESTS = 'ADD_ACTIVE_REQUEST'
export const SUB_ACTIVE_REQUESTS = 'SUB_ACTIVE_REQUEST'
export const SET_ALERT_NOTIFICATIONS = 'SET_ALERT_NOTIFICATIONS'
export const SET_ANNOTATION_TYPES = 'SET_ANNOTATION_TYPES'
export const SET_ARLS = 'SET_ARLS'
export const SET_CAPABILITIES = 'SET_CAPABILITIES'
export const SET_CITIES = 'SET_CITIES'
export const SET_CLIENTS = 'SET_CLIENTS'
export const SET_CLIENT_PEOPLE = 'SET_CLIENT_PEOPLE'
export const SET_CLIENT_TYPES = 'SET_CLIENT_TYPES'
export const SET_EXECUTIVES = 'SET_EXECUTIVES'
export const SET_IDENTIFICATION_TYPES = 'SET_IDENTIFICATION_TYPES'
export const SET_ITEM_TYPES = 'SET_ITEM_TYPES'
export const SET_MAIL_TYPES = 'SET_MAIL_TYPES'
export const SET_MONTHS = 'SET_MONTHS'
export const SET_PASSENGER_TYPES = 'SET_PASSENGER_TYPES'
export const SET_PEOPLE = 'SET_PEOPLE'
export const SET_PETITION_STATUSES = 'SET_PETITION_STATUSES'
export const SET_PETITION_TYPES = 'SET_PETITION_TYPES'
export const SET_POSITIONS = 'SET_POSITIONS'
export const SET_PROFILES = 'SET_PROFILES'
export const SET_RESTRICTED_VISITORS = 'SET_RESTRICTED_VISITORS'
export const SET_SELECTED_ROUND = 'SET_SELECTED_ROUND'
export const SET_SELECTED_STORE = 'SET_SELECTED_STORE'
export const SET_STRUCTURE_TYPES = 'SET_STRUCTURE_TYPES'
export const SET_SUPERVISOR = 'SET_SUPERVISOR'
export const SET_SUPERVISORS = 'SET_SUPERVISORS'
export const SET_SUPERVISION_CLIENT = 'SET_SUPERVISION_CLIENT'
export const SET_TOOLS = 'SET_TOOLS'
export const SET_VALID_YEARS = 'SET_VALID_YEARS'
export const SET_VEHICLE_ENTRY_MASTER_DATA = 'SET_VEHICLE_ENTRY_MASTER_DATA'
export const SET_VEHICLE_TYPES = 'SET_VEHICLE_TYPES'
export const SET_VISITOR_TYPES = 'SET_VISITOR_TYPES'
export const SET_SELECTED_BODYGUARD_SERVICE = 'SET_SELECTED_BODYGUARD_SERVICE'
export const SET_CURRENT_EVALUATION = 'SET_CURRENT_EVALUATION'
export const SET_CURRENT_EVALUATED_USER = 'SET_CURRENT_EVALUATED_USER'
